import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import VideoComponent from '../../demo-components/wellness/video-component';
import { useScrollToTop, useShow } from '../../hooks';

const WellnessVideoPage = () => {
  const { videoId } = useParams<{ videoId: string }>();
  const navigate = useNavigate();
  useScrollToTop();
  
  const { entity: video, loading, handleShow } = useShow('videos');

  useEffect(() => { 
    if (videoId) {
      handleShow(videoId);
    }
  }, [ videoId, handleShow ]);

  const handleBack = useCallback(() => {
    navigate('/wellness');
  }, [ navigate ]);

  if (loading) {
    return <div>Loading video...</div>;
  }

  if (!video && !loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <h1 style={{ color: '#333', marginBottom: '16px' }}>Video Not Found</h1>
        <p style={{ color: '#666', marginBottom: '24px' }}>The video you're looking for doesn't exist.</p>
        <button
          onClick={() => navigate('/wellness')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#4285F4',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Back to Wellness
        </button>
      </div>
    );
  }

  return <VideoComponent video={video} onBack={handleBack} />;
};

export default WellnessVideoPage;
